import clsx from 'clsx'
import Link from 'next/link'

import { Text } from '@wartek-id/text'
import { Icon } from '@wartek-id/icon'
import { Badge } from '@wartek-id/badge'
import { Button } from '@wartek-id/button'

import type { OverallProgress } from 'types/microlearning'

type CertificateTopicProps = {
  progressData: OverallProgress
}

const CertificateTopic = ({ progressData }: CertificateTopicProps) => {
  const isAllPassed = progressData?.modules.every(
    (module) => module?.postTest === 'passed'
  )

  const CARD_STATE = {
    passed: {
      iconBackground: 'bg-icon-informational',
      badgeText: 'Tersedia',
      infoText: 'Unduh surat keterangan selesai topik pelatihan mandiri.',
      buttonUrl: `/pelatihan-mandiri/topik/${progressData?.id}/surat-selesai-belajar`,
    },
    'not-passed': {
      iconBackground: 'bg-icon-disabled',
      badgeText: 'Belum Tersedia',
      infoText:
        'Selesaikan semua modul untuk mendapatkan surat keterangan selesai topik pelatihan mandiri',
      buttonUrl: '',
    },
  }

  const { iconBackground, badgeText, infoText, buttonUrl } = isAllPassed
    ? CARD_STATE.passed
    : CARD_STATE['not-passed']

  return (
    <div className="px-3 mt-6">
      <Text variant="heading-md">Surat Keterangan Selesai Topik</Text>

      <div className="flex gap-3 border border-subdued rounded p-4 bg-white mt-2">
        <div
          className={clsx(
            'flex justify-center flex-shrink-0 items-center w-8 h-8 rounded-full overflow-hidden',
            iconBackground
          )}
        >
          <Icon as="i" fontSize="sm" color="inverse">
            download_outlined
          </Icon>
        </div>
        <div className="w-full">
          <Badge className="mb-2">{badgeText}</Badge>
          <Text color="subdued" variant="body-sm" data-testid="card-element">
            {infoText}
          </Text>

          {buttonUrl && (
            <Link href={buttonUrl} passHref>
              <Button color="black" fullWidth size="md" className="mt-4">
                Unduh Surat
              </Button>
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}

export default CertificateTopic
